import { Page, Spinner } from "@patternfly/react-core";

// レイアウトをつかうため
// pf-l-gallery
import '@patternfly/react-core/dist/styles/base.css';

import "./style.css";

//import { Header } from "@keycloak/keycloak-account-ui";
import { Header } from "./Header";
import { Suspense, useState, useLayoutEffect  } from "react";
import { Outlet } from "react-router-dom";
import { PageNav } from "./PageNav";
import { NavLink, useLocation } from "react-router-dom";
import { routes } from "./routes";
import { Footer } from "./Footer";
import { useEnvironment, AccountEnvironment } from "@keycloak/keycloak-account-ui";
import { useTranslation } from "react-i18next";


type NavButtonProps = {
  label: string;
  path: string;
  onClick?: () => void;
};
function NavButton({ label, path, onClick }:NavButtonProps){
  return (
    <div className="pf-v5-l-gallery__item menu-button">
      <div className="nc-menue_helptext">
        <p>{/* マージンのため？？ */} </p>
      </div>
      <div className="nc-c-card__body">
        <div className="nc-menu_item">
          {onClick ? (
            <button className="nc-button navlink-style" onClick={onClick}>
              {label}
            </button>
          ) : (
            <NavLink key={path} to={path!}>
              {label}
            </NavLink>
          )}
        </div>
      </div>
    </div>     
  );
};

type BackButtonProps = {
  label: string;
  path: string;
};
function BackButton({ label, path }:BackButtonProps){
  return (
    <div className="pf-v5-l-gallery__item menu-button">
      <div className="nc-menue_helptext">
        <p>{/* マージンのため？？ */} </p>
      </div>
      <div className="nc-mypagelink-tunderline">
        <NavLink
          key={path}
          to={path}
        >
          {label}
        </NavLink>
      </div>
    </div>     
  );
};


type LinkButtonProps = {
  label: string;
  path: string;
  index: number;
};
function LinkButton({ label, path,index }:LinkButtonProps){
  const hideHelp = index === 1 || index === 4 || index === 5;
  return (
    <div className="pf-v5-l-gallery__item menu-button">
      {!hideHelp && (
        <div className={`nc-menue_helptext ${hideHelp ? "is-hidden" : ""}`}>
          <p>アプリをお持ちの場合はこちら</p>
        </div>
      )}
      <div className="nc-c-card__body">
        <div className="nc-menu_item">
          <NavLink
            to={path}
            target="_blank"
          >{label}</NavLink>
        </div>
      </div>
    </div>     
  );
};

function App() {
  const { t } = useTranslation();
  const location = useLocation();

  useLayoutEffect(() => {
    document.title = t("accountManagementTitle");
  }, [location.pathname, t]);

  const currentPath = location.pathname;
  const normalize = (path: string) => path.endsWith("/") ? path.slice(0, -1) : path;
  const baseURL = routes[0]?.path ?? "";
  const basePath = normalize(baseURL);
  const currentPathNormalized = normalize(currentPath);
  const relativePath = currentPathNormalized.replace(basePath, "");
  const isPortal = relativePath === "";

   // ログイン状態を取得するため
  const context = useEnvironment<AccountEnvironment>();
  const keycloak = context.keycloak;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  if( ! keycloak.authenticated && ! isPortal ){ 
      keycloak.login();
  }

  return (
      <Page
        sidebar= { isPortal ? null : <PageNav isMenuOpen={isMenuOpen} /> }
        header={<Header pageToggleButton={!isPortal} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />}
        // isManagedSidebar
      >
        { isPortal && (
          <section className="pf-v5-c-page__main-section  pf-m-limit-width pf-m-shadow-bottom">
            <div className="pf-c-page__main-body">
              <div className="pf-v5-c-content">
                <h1>{t("accountManagementWelcomeMessage")}</h1>
              </div>
            </div>
          </section>
        )}
        <div className="pf-v5-c-page__main-section pf-m-limit-width pf-m-overflow-scroll">
        { isPortal && (
          <section  className="pf-v5-c-page__main-body nc-body-background">
            <div>
              <div className="nc-gallery">{/* メニューを縦にレイアウトするための div 要素 */}
                <span className="nc-menue-category">{t("index.menuTitle_mypage")}</span>
                <div className="pf-v5-l-gallery pf-v5-m-gutter">
                  <NavButton label={t("personalInfoHtmlTitle")} path="personal-info" />
                  <NavButton label={t("emailPage.title")} path="email" />
                  <NavButton label={t("signingIn/account-security")} path="account-security/signingIn" />
                  <NavButton label={t("deleteAccount")} path="" onClick={() => keycloak.login({ action: "delete_nihonchouzai_account" })} />
                </div>
              </div>
              <div className="nc-gallery">{/* メニューを縦ににレイアウトするための div 要素 */}
                <span className="nc-menue-category">{t("index.menuTitle_ncService")}</span>
                <div className="pf-v5-l-gallery pf-v5-m-gutter"  style={{["--pf-l-gallery--GridTemplateColumns--min" as any]: "300px"}}>
                  <LinkButton index={1} label={t("index.menuList_okusuri.pc")} path="https://www.okusuriplus.com/" />
                  <LinkButton index={2} label={t("index.menuList_okusuri.mobile.android")} path="https://play.google.com/store/apps/details?id=jp.co.nicho.jpokusuri" />
                  <LinkButton index={3} label={t("index.menuList_okusuri.mobile.ios")} path="https://apps.apple.com/jp/app/id947740067" />
                </div>
                <div className="pf-v5-l-gallery pf-v5-m-gutter">{/* ボタンを横幅分だけ横にレイアウトするための div 要素 */}
                  <LinkButton index={4} label={t("index.menuList_nicoms.pc")} path="https://online-pharmacy.nicho.co.jp/#/auth/login?ons=JPACCOUNT" />            
                </div>
                <div className="pf-v5-l-gallery pf-v5-m-gutter">{/* ボタンを横幅分だけ横にレイアウトするための div 要素 */}
                  <LinkButton index={5} label={t("index.menuList_onlinestore.pc")} path="https://estore.nicho.co.jp/" />            
                </div>
              </div>
            </div>
          </section>
        )}

      <section>
        { ( keycloak.authenticated && ! isPortal ) && (
          <BackButton label={t("sendTopPage")} path=""  />
        )}
        {keycloak.authenticated && (
          <Suspense fallback={<Spinner />}>
            <Outlet />
          </Suspense>
        )}
      </section>
      <Footer />
      </div>
      </Page>
    );
}

export default App;
